export { WhyCinchCarousel } from './why-cinch-carousel'
